import { createAsyncReducer, createReducerFromMap, createDefaultInitialState } from "@coverme/redux";

const initialState = createDefaultInitialState([]);

function resetInterview() {
    return initialState;
}

function setHistory(state, { value }) {
    value.map(x => {
        if (x.isMarketplaceCreditApproved && x.selectedProgram === "Cash") {
            x.selectedProgram = "Credit";
        }
    });
    return value;
}

export const encounterHistoryReducer = createReducerFromMap(initialState, {
    ...createAsyncReducer("GET_ENCOUNTER_HISTORY", setHistory),
    RESET_INTERVIEW: resetInterview,
});
